export const HECTO = 100
export const KILO = 1000
export const MEGA = 1000000
